module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 28
// module chunks = 0